/*
 * Leaflet.TextPath - Shows text along a polyline
 * Inspired by Tom Mac Wright article :
 * http://mapbox.com/osmdev/2012/11/20/getting-serious-about-svg/
 */

(function () {

var __onAdd = L.Polyline.prototype.onAdd,
    __onRemove = L.Polyline.prototype.onRemove,
    __updatePath = L.Polyline.prototype._updatePath,
    __bringToFront = L.Polyline.prototype.bringToFront;


var PolylineTextPath = {

    onAdd: function (map) {
        __onAdd.call(this, map);
        this._textRedraw();
    },

    onRemove: function (map) {
        map = map || this._map;
        if (map && this._textNodes && map._renderer._container) {
            var el;
            while(el=this._textNodes.pop()) {
               if (el && el.parentNode) {
                  this._map._renderer._container.removeChild(el);
               }
            }
        }
        __onRemove.call(this, map);
    },

    bringToFront: function () {
        __bringToFront.call(this);
        this._textRedraw();
    },

    _updatePath: function () {
        __updatePath.call(this);
        this._textRedraw();
    },

    _textRedraw: function () {
        var text = this._text,
            options = this._textOptions;
        if (text) {
            this.setText(null).setText(text, options);
        }
    },

    setText: function (text, options) {
        this._text = text;
        this._textOptions = options;

        if (typeof(this._textNodes) === 'undefined') {
           this._textNodes = [];
        }

        /* If not in SVG mode or Polyline not added to map yet return */
        /* setText will be called by onAdd, using value stored in this._text */
        if (!L.Browser.svg || typeof this._map === 'undefined') {
          return this;
        }

        /* If empty text, hide */
        if (!text) {
            var el;
            while(el=this._textNodes.pop()) {
               if (el && el.parentNode) {
                  this._map._renderer._container.removeChild(el);
               }
            }
            return this;
        }

        var defaults = {
            repeat: false,
            fillColor: 'black',
            attributes: {},
            below: false,
        };
        options = L.Util.extend(defaults, options);

        text = text.replace(/ /g, '\u00A0');  // Non breakable spaces
        var id = 'pathdef-' + L.Util.stamp(this);
        var svg = this._map._renderer._container;
        this._path.setAttribute('id', id);

        /* Put it along the path using textPath */
        var times = 5;
        for(var i=1; i<times && this._map.getZoom() >= 14; i++) {

            var textNode = L.SVG.create('text'),
                textPath = L.SVG.create('textPath');

            var dy = options.offset || this._path.getAttribute('stroke-width');

            textPath.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", '#'+id);
            textNode.setAttribute('dy', dy);
            for (var attr in options.attributes)
                textNode.setAttribute(attr, options.attributes[attr]);
            textPath.appendChild(document.createTextNode(text));
            textNode.appendChild(textPath);

            if (options.below) {
                svg.insertBefore(textNode, svg.firstChild);
            } else {
                svg.appendChild(textNode);
            }

            this._textNodes[i-1] = textNode;

            /* Center text according to the path's bounding box */
            var perc = (100/times)*i;
            textNode.setAttribute('text-anchor', 'middle');
            textPath.setAttribute('startOffset', perc+'%');
        }

        return this;
    }
};

L.Polyline.include(PolylineTextPath);

L.LayerGroup.include({
    setText: function(text, options) {
        for (var layer in this._layers) {
            if (typeof this._layers[layer].setText === 'function') {
                this._layers[layer].setText(text, options);
            }
        }
        return this;
    }
});



})();
